// import type { VNode, RendererNode, RendererElement, ExtractPropTypes, PropType, HTMLAttributes } from 'vue'
import { MentionsopenDialogValue } from './mentionsTypes';

export function filterOption(input, { label = '' }) {
  const lowerCase = input.toLowerCase();
  if (label === MentionsopenDialogValue) {
    return true;
  }
  return label.toLowerCase().indexOf(lowerCase) !== -1;
}

export function generateGetBoundingClientRect(x = 0, y = 0) {
  return () => ({
    width: 0,
    height: 0,
    top: y,
    right: x,
    bottom: y,
    left: x,
    x,
    y
  });
}

export const getCursorPosition = () => {
  const selection = window.getSelection();
  if (!selection || !selection.rangeCount) return { x: 0, y: 0 };

  const range = selection.getRangeAt(0);
  const clonedRange = range.cloneRange();
  clonedRange.collapse(true);

  const tempSpan = document.createElement('span');
  tempSpan.textContent = '|';
  tempSpan.style.display = 'inline-block';
  tempSpan.style.width = '0px';
  tempSpan.style.overflow = 'hidden';

  clonedRange.insertNode(tempSpan);

  const rect = tempSpan.getBoundingClientRect();
  const x = rect.left;
  const y = rect.top + rect.height;

  tempSpan.parentNode.removeChild(tempSpan);

  selection.removeAllRanges();
  selection.addRange(range);

  return { x, y };
};

function lower(char) {
  return (char || '').toLowerCase();
}

function reduceText(text, targetText, split) {
  const firstChar = text[0];
  if (!firstChar || firstChar === split) {
    return text;
  }

  let restText = text;
  const targetTextLen = targetText.length;
  for (let i = 0; i < targetTextLen; i += 1) {
    if (lower(restText[i]) !== lower(targetText[i])) {
      restText = restText.slice(i);
      break;
    } else if (i === targetTextLen - 1) {
      restText = restText.slice(targetTextLen);
    }
  }

  return restText;
}

export function replaceWithMeasure(text, measureConfig) {
  const { measureLocation, prefix, targetText, selectionStart, split } =
    measureConfig;

  let beforeMeasureText = text.slice(0, measureLocation);
  if (beforeMeasureText[beforeMeasureText.length - split.length] === split) {
    beforeMeasureText = beforeMeasureText.slice(
      0,
      beforeMeasureText.length - split.length
    );
  }
  if (beforeMeasureText) {
    beforeMeasureText = `${beforeMeasureText}${split}`;
  }

  let restText = reduceText(
    text.slice(selectionStart),
    targetText.slice(selectionStart - measureLocation - prefix.length),
    split
  );
  if (restText.slice(0, split.length) === split) {
    restText = restText.slice(split.length);
  }

  const connectedStartText = `${beforeMeasureText}${prefix}${targetText}${split}`;

  return {
    text: `${connectedStartText}${restText}`,
    selectionLocation: connectedStartText.length
  };
}

export const getOffsetText = () => {
  const selecttion = window.getSelection();
  if (selecttion) {
    const range = selecttion.getRangeAt(0);
    const { startContainer } = range;
    const { startOffset } = range;
    if (startContainer.textContent) {
      const offsetText = startContainer.textContent.slice(0, startOffset);
      return offsetText;
    }
    return '';
  }
  return '';
};
export function insertMention(
  range,
  mentionText,
  value,
  mentionClass,
  mentionsStyle
) {
  const mentionNode = document.createElement('span');
  mentionNode.innerText = `${mentionText}`;
  mentionNode.setAttribute('class', mentionClass);
  mentionNode.setAttribute('data-id', value);
  mentionNode.setAttribute('data-name', mentionText);
  mentionNode.setAttribute('contenteditable', 'false');
  mentionNode.style = mentionsStyle;
  mentionNode.style.userSelect = 'all';

  // Add zero-width space before mention
  const beforeSpace = document.createTextNode('\u200B');
  range.insertNode(beforeSpace);
  range.setStartAfter(beforeSpace);
  range.insertNode(mentionNode);

  // Add zero-width space after mention
  const afterSpace = document.createTextNode('\u200B');
  mentionNode.parentNode.insertBefore(afterSpace, mentionNode.nextSibling);

  // Add empty text node for cursor position
  const textNode = document.createTextNode('');
  mentionNode.parentNode.insertBefore(textNode, afterSpace.nextSibling);

  const newRange = document.createRange();
  newRange.setStart(textNode, 0);
  newRange.collapse(true);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(newRange);
}
export function deleteContentAfterAtSign(range, sign) {
  const { startContainer } = range;
  const { startOffset } = range;
  const textBeforeRange = startContainer.textContent.slice(0, startOffset);
  const atIndex = textBeforeRange.lastIndexOf(sign);

  if (atIndex !== -1) {
    // const textToDelete = textBeforeRange.slice(atIndex)
    // const deletedLength = textToDelete.length
    range.setStart(startContainer, atIndex);
    range.deleteContents();
    // console.log('del', deletedLength)
  } else {
    // console.log(' @ ')
  }
}

export function insertText(range, text) {
  const textNode = document.createTextNode(text);
  range.insertNode(textNode);
}
